module.exports = __webpack_public_path__ + "static/img/23.888b2eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/23.png
// module id = BZSd
// module chunks = 0